// 商品ページにギフトオプション追加_2026.4.15_佐藤

// gift-add-interceptor.js

// 役割:
// - テーマ / Globo / 既存JS が送る /cart/add.js を横取り
// - gift_option が add のときだけ、request body を同時追加用に変換
//
// 方針:
// - /cart/add.js 自体は編集しない
// - 送信直前の body だけ書き換える
// - テーマ本来の add → drawer 更新フローは生かす
//
// 使用キー:
// - _gift_type
// - _gift_item
// - _gift_variant

(function () {
  'use strict';

  function log(...args) {
    console.log('[gift-add-interceptor]', ...args);
  }

  function sanitizeVariantId(value) {
    if (!value) return '';
    const s = String(value).trim();

    if (s.includes('gid://shopify/ProductVariant/')) {
      return s.split('/').pop() || '';
    }

    const match = s.match(/\d{8,}/);
    return match ? match[0] : '';
  }

  function getProductTitle() {
    const titleEl =
      document.querySelector('.product-page-info__title') ||
      document.querySelector('.product__title') ||
      document.querySelector('h1');

    return titleEl ? titleEl.textContent.trim() : document.title || '';
  }

  function getProductContainer() {
    return (
      document.querySelector('.product-page') ||
      document.querySelector('.product') ||
      document
    );
  }

  function getSelectedVariantTitle() {
    const container = getProductContainer();

    const variantSelect =
      container.querySelector('form select[name="id"]') ||
      container.querySelector('select[name="id"]');

    if (variantSelect && variantSelect.selectedOptions && variantSelect.selectedOptions[0]) {
      const text = variantSelect.selectedOptions[0].textContent.trim();
      if (text) {
        return text.replace(/\s*-\s*¥?[\d,].*$/, '').trim();
      }
    }

    const variantTitleEl =
      container.querySelector('.product-page-info__variant') ||
      container.querySelector('.product-form__selected-variant') ||
      container.querySelector('[data-variant-title]');

    if (variantTitleEl) {
      const text = variantTitleEl.textContent.trim();
      if (text) return text;
    }

    const checkedRadios = Array.from(
      container.querySelectorAll('input[type="radio"]:checked')
    );

    const labels = checkedRadios
      .map(input => {
        const label =
          input.closest('label') ||
          container.querySelector(`label[for="${input.id}"]`);
        return label ? label.textContent.trim() : '';
      })
      .filter(Boolean);

    if (labels.length) {
      return labels.join(' / ');
    }

    return '';
  }

  function getGiftSelectionFromDOM() {
    const selectedRadio = document.querySelector('input[name="gift_option"]:checked');
    if (!selectedRadio) {
      return {
        selected: 'none',
        giftVariantId: '',
        giftTypeLabel: ''
      };
    }

    return {
      selected: selectedRadio.value || 'none',
      giftVariantId: sanitizeVariantId(selectedRadio.dataset.giftVariantId || ''),
      giftTypeLabel: selectedRadio.dataset.propertyName || ''
    };
  }

  function isCartAddRequest(url, method) {
    if (!url) return false;
    return url.includes('/cart/add.js') && String(method || 'GET').toUpperCase() === 'POST';
  }

  function parseJsonBody(body) {
    if (!body) return null;

    if (typeof body === 'string') {
      try {
        return JSON.parse(body);
      } catch (e) {
        return null;
      }
    }

    return null;
  }

  function hasGiftAlready(payload) {
    if (!payload || !Array.isArray(payload.items)) return false;
    return payload.items.some(item =>
      item &&
      item.properties &&
      item.properties._gift_type
    );
  }

  function buildModifiedPayload(originalPayload, giftSelection) {
    if (!originalPayload || !Array.isArray(originalPayload.items) || !originalPayload.items.length) {
      return originalPayload;
    }

    if (giftSelection.selected !== 'add') {
      return originalPayload;
    }

    if (!giftSelection.giftVariantId || !giftSelection.giftTypeLabel) {
      return originalPayload;
    }

    if (hasGiftAlready(originalPayload)) {
      return originalPayload;
    }

    const productTitle = getProductTitle();
    const variantTitle = getSelectedVariantTitle();

    const firstItem = originalPayload.items[0];
    const mainVariantId = sanitizeVariantId(firstItem.id);

    if (!mainVariantId) {
      return originalPayload;
    }

    const clonedPayload = typeof structuredClone === 'function'
      ? structuredClone(originalPayload)
      : JSON.parse(JSON.stringify(originalPayload));

    const clonedMainItem = clonedPayload.items[0];
    if (!clonedMainItem.properties) {
      clonedMainItem.properties = {};
    }

    // UI管理用の一時 hidden property は送らない
    delete clonedMainItem.properties._gift_selected;
    delete clonedMainItem.properties._gift_variant_id;
    delete clonedMainItem.properties._gift_type_label;
    delete clonedMainItem.properties._gift_display_value;

    clonedPayload.items.push({
      id: Number(giftSelection.giftVariantId),
      quantity: Number(clonedMainItem.quantity || 1),
      properties: {
        _gift_type: giftSelection.giftTypeLabel,
        _gift_item: productTitle,
        _gift_variant: variantTitle
      }
    });

    return clonedPayload;
  }

  function cleanupGiftHelperProperties(payload) {
    if (!payload || !Array.isArray(payload.items)) return payload;

    payload.items.forEach(item => {
      if (!item || !item.properties) return;

      delete item.properties._gift_selected;
      delete item.properties._gift_variant_id;
      delete item.properties._gift_type_label;
      delete item.properties._gift_display_value;
    });

    return payload;
  }

  const originalFetch = window.fetch;
  window.fetch = async function (...args) {
    const [input, options = {}] = args;
    const requestUrl = typeof input === 'string' ? input : input?.url || '';
    const method = options?.method || 'GET';

    if (isCartAddRequest(requestUrl, method)) {
      try {
        const jsonBody = parseJsonBody(options.body);
        if (jsonBody && Array.isArray(jsonBody.items)) {
          const giftSelection = getGiftSelectionFromDOM();

          log('intercept fetch cart/add.js', {
            giftSelection,
            originalBody: jsonBody
          });

          let modifiedPayload = buildModifiedPayload(jsonBody, giftSelection);
          modifiedPayload = cleanupGiftHelperProperties(modifiedPayload);

          options.body = JSON.stringify(modifiedPayload);

          log('modified fetch payload', modifiedPayload);
        }
      } catch (e) {
        console.error('[gift-add-interceptor] fetch intercept failed', e);
      }
    }

    return originalFetch.call(this, input, options);
  };

  (function patchXHR() {
    const originalOpen = XMLHttpRequest.prototype.open;
    const originalSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this._giftInterceptorMethod = method;
      this._giftInterceptorUrl = url;
      return originalOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function (body) {
      try {
        const url = this._giftInterceptorUrl || '';
        const method = this._giftInterceptorMethod || 'GET';

        if (isCartAddRequest(url, method)) {
          const jsonBody = parseJsonBody(body);

          if (jsonBody && Array.isArray(jsonBody.items)) {
            const giftSelection = getGiftSelectionFromDOM();

            log('intercept xhr cart/add.js', {
              giftSelection,
              originalBody: jsonBody
            });

            let modifiedPayload = buildModifiedPayload(jsonBody, giftSelection);
            modifiedPayload = cleanupGiftHelperProperties(modifiedPayload);

            body = JSON.stringify(modifiedPayload);

            log('modified xhr payload', modifiedPayload);
          }
        }
      } catch (e) {
        console.error('[gift-add-interceptor] xhr intercept failed', e);
      }

      return originalSend.call(this, body);
    };
  })();

  log('initialized');
})();